import { DSStatus } from 'shared'
import {
  DesignSubmittal,
  useDesignSubmittalLogContext,
} from '../../../../../../DesignSubmittalLogContext'
import { useAuthContext } from 'context/AuthContext'
import { DefaultMutationHookOptions } from 'utils/defaults'
import { simpleEditNotification } from 'hooks/notificationHandler'
import { CIMSTags } from 'components/CIMSTags'
import { useSetDsToDsDisciplineMutation } from 'schema'
import CIMSChecklist from 'components/CIMSChecklist'

export const Disciplines: React.VFC<DesignSubmittal> = ({
  id,
  statusId,
  deleted,
  dsToDSDisciplines,
}) => {
  const { user } = useAuthContext()
  const {
    refetch,
    permissions: { canReviewAll },
  } = useDesignSubmittalLogContext()
  const canAccept = (
    disciplineId: string,
    dsToDSDisciplines: DesignSubmittal['dsToDSDisciplines']
  ) => {
    if (canReviewAll) return true
    if (!user) return false

    return dsToDSDisciplines
      .filter(({ discipline: { users } }) =>
        users.map(({ id }) => id).includes(user.id)
      )
      .map(({ discipline: { id } }) => id)
      .includes(disciplineId)
  }

  const [set] = useSetDsToDsDisciplineMutation({
    ...DefaultMutationHookOptions,
    onCompleted: ({
      setDSToDSDiscipline: {
        discipline: { name },
      },
    }) => {
      simpleEditNotification(name)
    },
  })
  return (
    <>
      {statusId === DSStatus.DisciplineAction.id ? (
        <CIMSChecklist
          items={dsToDSDisciplines.map(
            ({ accepted, discipline: { name, id: disciplineId } }) => ({
              key: `${id}_${disciplineId}`,
              tag: { children: name },
              checked: accepted,
              disabled: [
                {
                  disabled: !canAccept(disciplineId, dsToDSDisciplines),
                  reason: 'missing permission',
                },
                {
                  disabled: deleted,
                  reason: {
                    why: 'inactive',
                    entityName: 'Design Submittal',
                  },
                },
              ],
              onChange: async () => {
                await set({
                  variables: {
                    input: {
                      accepted: !accepted,
                      submittalId: id,
                      disciplineId,
                    },
                  },
                })
                await refetch()
              },
            })
          )}
        />
      ) : (
        <CIMSTags
          direction={{ tags: 'vertical' }}
          tags={dsToDSDisciplines.map(
            ({ discipline: { name, id, description } }) => ({
              text: name,
              key: id,
              tooltip: description,
            })
          )}
        />
      )}
    </>
  )
}
